/* Elite Sport — offre de bienvenue : état et activation du code sans navigation, pastille flottante, lignes du panier.
   Chargé par snippets/es-head.liquid ; le code vient de l'attribut data-es-discount-code (Réglages du thème → Elite Sport · Offre de bienvenue).
   État dérivé de cart.discount_codes (/cart.js, un appel par page, relu à chaque mise à jour du panier) : active | superseded | off,
   exposé sur <html> par data-es-offer-state.
   API : ESDiscount.isActive(), ESDiscount.getState(), ESDiscount.activate(source) → Promise(boolean), ESDiscount.ready.
   Événement document « es:discount-change » { active, state, source } + Shopify.analytics.publish('es_discount_activated', { source }). */
(function () {
  var tag = document.querySelector('script[data-es-discount-code]');
  var code = tag ? (tag.getAttribute('data-es-discount-code') || '').trim() : '';
  if (!code) return;

  var html = document.documentElement;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = null;
  var pending = null;
  var ready;

  /* Repli uniquement : le cookie ne sert que si /cart.js ne répond pas */
  function cookieActive() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      return !!m && decodeURIComponent(m[1]).toLowerCase().split(',').indexOf(code.toLowerCase()) > -1;
    } catch (e) {
      return false;
    }
  }

  /* Source de vérité : cart.discount_codes
     active     : le code est présent et applicable, ou présent dans un panier vide
     superseded : un autre code applicable occupe le panier (le nôtre absent ou non applicable) → plus aucun appel à activer
     off        : sinon */
  function derive(cart) {
    var mine = false;
    var mineOk = false;
    var other = false;
    (cart.discount_codes || []).forEach(function (d) {
      if (String(d.code).toLowerCase() === code.toLowerCase()) {
        mine = true;
        mineOk = d.applicable === true;
      } else if (d.applicable === true) {
        other = true;
      }
    });
    if (mine && (mineOk || cart.item_count === 0)) return 'active';
    return other ? 'superseded' : 'off';
  }

  function load(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(derive)
      .catch(function () {
        return cookieActive() ? 'active' : 'off';
      });
  }

  /* État unique sur <html> : data-es-offer-state="active|superseded|off" + classe es-welcome-on (bascule data-es-welcome="on|off"),
     et événement es:discount-change */
  function apply(next, source) {
    var changed = next !== state;
    state = next;
    html.setAttribute('data-es-offer-state', next);
    html.classList.toggle('es-welcome-on', next === 'active');
    if (changed || source) {
      document.dispatchEvent(new CustomEvent('es:discount-change', { detail: { active: next === 'active', state: next, code: code, source: source } }));
    }
    return next === 'active';
  }

  function refresh() {
    ready = load(root + 'cart.js').then(function (next) {
      return apply(next);
    });
    return ready;
  }

  /* Avant la réponse de /cart.js : état provisoire posé par es-head */
  function isActive() {
    return state === null ? html.classList.contains('es-welcome-on') : state === 'active';
  }

  /* Le lien natif applique le code puis redirige : on le fait suivre vers cart.js, dont la réponse donne le nouvel état, sans quitter la page.
     Autre code en place (superseded) : on n'y touche pas, aucun appel, aucun événement analytics */
  function activate(source) {
    if (pending) return pending;
    var url = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js');
    pending = ready
      .then(function () {
        return state === 'off' ? load(url) : state;
      })
      .then(function (next) {
        pending = null;
        if (next === 'active' && state !== 'active') {
          try {
            Shopify.analytics.publish('es_discount_activated', { source: source });
          } catch (e) {}
          return apply(next, source);
        }
        return apply(next);
      });
    return pending;
  }

  function getState() {
    return state;
  }

  window.ESDiscount = { code: code, isActive: isActive, getState: getState, activate: activate, refresh: refresh };
  refresh();
  window.ESDiscount.ready = ready;

  /* Ajout ou modification du panier par Dawn : l'état est relu */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);

  /* Sans JS (ou nouvel onglet), le lien revient sur la page courante, paramètres compris (Liquid ne connaît que le chemin) */
  [].forEach.call(document.querySelectorAll('a[href*="/discount/"]'), function (a) {
    var h = a.getAttribute('href') || '';
    a.setAttribute('href', h.split('?')[0] + '?redirect=' + encodeURIComponent(location.pathname + location.search));
  });

  /* Tous les liens /discount/ et les boutons data-es-discount="<source>" passent par activate() */
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-es-discount],a[href*="/discount/"]') : null;
    if (!el || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (el.getAttribute('aria-busy') === 'true') return;
    el.setAttribute('aria-busy', 'true');
    activate(el.getAttribute('data-es-discount') || 'link').then(function (ok) {
      el.removeAttribute('aria-busy');
      /* Échec du fetch (réseau, bloqueur) : on retombe sur le lien natif */
      if (!ok && state !== 'superseded' && el.getAttribute('href')) location.assign(el.href);
    });
  });

  /* Pastille flottante (snippets/es-discount-pill.liquid) */
  (function () {
    var pill = document.getElementById('es-pill');
    if (!pill) return;
    var KEY = 'es-pill-closed';
    var FIELD = 'input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=range]),textarea,select,[contenteditable="true"]';
    var status = pill.querySelector('.es-pill__ok');
    var space = document.querySelector('.es-pill-space');
    var bar = document.querySelector('.es-ann');
    var timer;

    try {
      if (sessionStorage.getItem(KEY) === '1') {
        if (space) space.hidden = true;
        return;
      }
    } catch (e) {}

    function show(s) {
      pill.setAttribute('data-state', s);
      if (s !== 'off') status.textContent = status.getAttribute(s === 'done' ? 'data-done' : 'data-mini');
    }

    show(isActive() ? 'mini' : 'off');
    pill.hidden = false;

    /* Visible seulement quand le bandeau d'annonce est sorti de l'écran */
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        pill.classList.toggle('is-in', !entries[entries.length - 1].isIntersecting);
      }).observe(bar);
    } else {
      pill.classList.add('is-in');
    }

    pill.querySelector('.es-pill__x').addEventListener('click', function () {
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
      pill.hidden = true;
      if (space) space.hidden = true;
    });

    document.addEventListener('es:discount-change', function (e) {
      clearTimeout(timer);
      if (!e.detail.active) return show('off');
      if (!e.detail.source) return show('mini');
      show('done');
      timer = setTimeout(function () {
        show('mini');
      }, 3000);
    });

    /* Clavier virtuel : la pastille s'efface pendant la saisie */
    document.addEventListener('focusin', function (e) {
      pill.classList.toggle('is-typing', !!(e.target.matches && e.target.matches(FIELD)));
    });
    document.addEventListener('focusout', function () {
      pill.classList.remove('is-typing');
    });

    /* Ne jamais recouvrir la bannière cookies (--es-offer-lift) ni la barre d'aperçu Shopify (--es-pill-offset = sa hauteur + 8px) */
    var queued = false;
    var watched = null;
    var sizes = window.ResizeObserver ? new ResizeObserver(queue) : null;
    function fromBottom(el) {
      if (!el) return 0;
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight;
      return r.height > 0 && r.bottom >= vh - 2 && r.top > vh / 2 ? vh - r.top : 0;
    }
    function lift() {
      queued = false;
      html.style.setProperty('--es-offer-lift', Math.ceil(fromBottom(document.getElementById('shopify-pc__banner'))) + 'px');
      var bar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      var h = fromBottom(bar) || fromBottom(bar && bar.querySelector('iframe'));
      if (h) html.style.setProperty('--es-pill-offset', Math.ceil(h) + 8 + 'px');
      else html.style.removeProperty('--es-pill-offset');
      if (sizes && bar !== watched) {
        if (watched) sizes.unobserve(watched);
        if (bar) sizes.observe(bar);
        watched = bar;
      }
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(lift);
    }
    lift();
    window.addEventListener('resize', queue);
    if (window.MutationObserver) {
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }
    document.addEventListener('visitorConsentCollected', function () {
      setTimeout(lift, 400);
    });
  })();

  /* Panier : après activation, total et ligne de remise relus via la Section Rendering API */
  function refreshCart() {
    var targets = [];
    var footer = document.getElementById('main-cart-footer');
    var items = document.getElementById('main-cart-items');
    if (document.querySelector('cart-drawer')) {
      targets.push({ id: 'cart-drawer', selector: '#CartDrawer-CartItems', scope: document });
      targets.push({ id: 'cart-drawer', selector: '.cart-drawer__footer', scope: document });
    }
    if (footer && footer.dataset.id) targets.push({ id: footer.dataset.id, selector: '.js-contents', scope: footer });
    if (items && items.dataset.id) targets.push({ id: items.dataset.id, selector: '.js-contents', scope: items });
    if (!targets.length) return;

    var ids = targets
      .map(function (t) {
        return t.id;
      })
      .filter(function (id, i, all) {
        return all.indexOf(id) === i;
      });
    var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
    fetch(cartUrl + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        targets.forEach(function (t) {
          if (!sections[t.id]) return;
          var src = new DOMParser().parseFromString(sections[t.id], 'text/html').querySelector(t.selector);
          var dst = t.scope.querySelector(t.selector);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('es:discount-change', function (e) {
    if (e.detail.source) refreshCart();
  });
})();
